var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import Location from "../models/ServiceDeliveryLocation";
import MeetingTopic from "../models/MeetingTopic";
import FetchService from "../src/Services/Shared/FetchService";
export default class MeetingService {
    /**
     * Gets the campus location of the currently logged in person.
     *
     * @param {string} personId - The ID of the person for whom to load the student campus location.
     * @param {number} campaignId - (Optional) the campaign id if we're considering the student' location in the context of
     *  a campaign.
     */
    static fetchCurrentLocation(personId, campaignId) {
        return __awaiter(this, void 0, void 0, function* () {
            return FetchService.getSingleResponse("/aviso/location/getLocationByPerson", {
                id: personId,
                campaignId,
            });
        });
    }
    /**
     * Gets locations that have service offerings.
     */
    static fetchLocationsWithServices(options = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            return FetchService.getSingleResponse("/aviso/serviceDeliveryLocation/getLocationsWithServices", { campaignId: options.campaignId });
        });
    }
    /**
     * Fetches a service delivery location.
     *
     * @param {number} teamId - The ID of the service delivery location to fetch.
     */
    // @ts-expect-error - TS7006 - Parameter 'teamId' implicitly has an 'any' type.
    static fetchTeam(teamId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield fetch(`/aviso/serviceDeliveryLocation/getServiceDeliveryLocation?id=${teamId}`, {
                credentials: "include",
            });
            const responseJson = yield response.json();
            return responseJson.data;
        });
    }
    /**
     * Fetches meeting topics (service offerings).
     *
     * @param {number} locationId - The location to filter on.
     * @param {string} personId - The ID of the person to filter topics on.
     * @param {number} serviceDeliveryLocationId - The service delivery location to filter on.
     */
    static fetchMeetingTopics(locationId, 
    // @ts-expect-error - TS2322 - Type 'null' is not assignable to type 'string'.
    personId = null, 
    // @ts-expect-error - TS2322 - Type 'null' is not assignable to type 'number'.
    serviceDeliveryLocationId = null) {
        return __awaiter(this, void 0, void 0, function* () {
            // Build the request URL.
            let url = `/aviso/serviceOffering/getServiceOfferings?locationId=${locationId}`;
            if (personId) {
                url += `&personId=${personId}`;
            }
            if (serviceDeliveryLocationId) {
                url += `&serviceDeliveryLocationId=${serviceDeliveryLocationId}`;
            }
            const response = yield fetch(url, {
                credentials: "include",
            });
            const meetingTopicsResponse = yield response.json();
            return meetingTopicsResponse.data.map(MeetingService.mapJsonToMeetingTopic);
        });
    }
    /**
     * Maps a JSON object into a new MeetingTopic instance.
     *
     * @param {object} jsonObject - The JSON response from the server representing a service
     * offering (Meeting Topic).
     */
    // @ts-expect-error - TS7006 - Parameter 'jsonObject' implicitly has an 'any' type.
    static mapJsonToMeetingTopic(jsonObject) {
        const model = new MeetingTopic();
        model.id = jsonObject.id;
        model.title = jsonObject.name;
        model.isSelected = false;
        return model;
    }
    /**
     * Fetches the available time slots for the specified person.
     *
     * @param {string} personId - The ID of the person to load availability slots for.
     * @param {Date} availabilityDate - The date for which to load availability.
     * @param {number} durationMinutes - The duration of the time slots (in minutes).
     * @param {object} cache - An object that serves as the request cache. When calling this
     * multiple times, pass the same object instance here to implement the cache system.
     * @param {any} serviceDeliveryLocation - The SDL of where the meeting is taking place
     * @param selectedTopic
     * @param campaign - The campaign id that this meeting request originated from
     */
    static fetchPersonTimeSlotsCached(personId, availabilityDate, durationMinutes, cache, serviceDeliveryLocation, selectedTopic, campaign) {
        return __awaiter(this, void 0, void 0, function* () {
            // Build the request URL.
            let url = `/aviso/calendar/getTimeSlots?personId=${personId}&availabilityDate=${availabilityDate.toJSON()}&durationMinutes=${durationMinutes}`;
            if (serviceDeliveryLocation !== null) {
                url += `&serviceDeliveryLocationId=${serviceDeliveryLocation.id}`;
            }
            if (selectedTopic !== null) {
                url += `&serviceOfferingId=${selectedTopic.id}`;
            }
            if (campaign != null) {
                url += `&campaign=${campaign}`;
            }
            return MeetingService.fetchWithCache(url, cache);
        });
    }
    /**
     * Fetches the available time slots fo the specified team.
     *
     * @param {number} topicId - The ID of the topic for which to load available time slots.
     * @param {number} teamId - The ID of the team (service delivery location) for which to load
     * available time slots.
     * @param {Date} availabilityDate - The date for which to load availability.
     * @param {number} durationMinutes - The duration of the time slots (in minutes).
     * @param campaign - The campaign id that this meeting request originated from
     * @param {object} cache - An object that serves as the request cache. When calling this
     * multiple times, pass the same object instance here to implement the cache system.
     */
    static fetchTeamTimeSlotsCached(topicId, teamId, availabilityDate, durationMinutes, campaign, cache) {
        const url = `/aviso/calendar/getAvailabilitySlotsByTeamAndDurationAndAvailabilityDate?topicId=${topicId}&teamId=${teamId}&availabilityDate=${availabilityDate.toJSON()}&durationMinutes=${durationMinutes}&campaign=${campaign}`;
        // @ts-expect-error - TS2740 - Type 'Promise<any>' is missing the following properties from type 'TimeSlot[]': length, pop, push, concat, and 29 more.
        return MeetingService.fetchWithCache(url, cache);
    }
    static fetchWithCache(url, cache) {
        return __awaiter(this, void 0, void 0, function* () {
            // Cache by the URL - if it's cached, return the results from that.
            let responseJson;
            if (cache[url]) {
                responseJson = cache[url];
            }
            else {
                const response = yield fetch(url, { credentials: "include" });
                responseJson = yield response.json();
                cache[url] = responseJson;
            }
            return responseJson;
        });
    }
    /**
     * Fetches the staff members and teams that provide services for a particular location.
     *
     * @param {number} locationId - The location for which to load staff and teams.
     * @param campaignId - The appointment campaign that brought the user to this page
     */
    static fetchStaffAndTeams(locationId, 
    // @ts-expect-error - TS2322 - Type 'null' is not assignable to type 'number'.
    campaignId = null) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield fetch(`/aviso/meeting/getStaffAndDepartments?` +
                // @ts-expect-error - TS2345 - Argument of type '{ locationId: number; campaignId: number; }' is not assignable to parameter of type 'string | string[][] | Record<string, string> | URLSearchParams | undefined'.
                new URLSearchParams({
                    locationId,
                    campaignId,
                }), {
                credentials: "include",
            });
            return response.json();
        });
    }
    /**
     * Fetches the service delivery locations relevant to the parameters.
     *
     * @param {number} locationId - The ID of the location of which to find associated service
     * delivery locations.
     * @param {string} meetingWithPersonId - The ID of the person that is selected to be met with.
     * @param {number} topicId - The topic selected.
     */
    static fetchServiceDeliveryLocations(locationId, 
    // @ts-expect-error - TS2322 - Type 'null' is not assignable to type 'string'.
    meetingWithPersonId = null, 
    // @ts-expect-error - TS2322 - Type 'null' is not assignable to type 'number'.
    topicId = null) {
        return __awaiter(this, void 0, void 0, function* () {
            let url = `/aviso/serviceDeliveryLocation/getServiceDeliveryLocations?locationId=${locationId}`;
            if (meetingWithPersonId) {
                url += `&personId=${meetingWithPersonId}`;
            }
            if (topicId) {
                url += `&serviceId=${topicId}`;
            }
            const response = yield fetch(url, {
                credentials: "include",
            });
            return response
                .json()
                .then((locs) => locs.map(MeetingService.mapJsonToServiceDeliveryLocation));
        });
    }
    // @ts-expect-error - TS7006 - Parameter 'jsonObject' implicitly has an 'any' type.
    static mapJsonToServiceDeliveryLocation(jsonObject) {
        const loc = new Location();
        loc.id = jsonObject.id;
        loc.name = jsonObject.name;
        loc.url = jsonObject.url;
        loc.isSelected = false;
        loc.location = {
            id: jsonObject.location.id,
            name: jsonObject.location.name,
        };
        return loc;
    }
    /**
     * Saves a schedule meeting on the server.
     *
     * @param {object} event - The event to save.
     */
    static saveEvent(event) {
        return FetchService.postSingleResponse("/aviso/calendar/create", event);
    }
}
